import { AxiosResponse } from 'axios';
import {
  SET_EVENTS,
  SET_EVENT,
  SET_UPCOMING_EVENTS,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  CLEAR_EVENT_ISLOADING,
  DELETE_EVENT,
  EDIT_EVENT,
  GET_EVENT,
  GET_EVENTS,
  GET_UPCOMING_EVENTS,
  REGISTER_EVENT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Event from '@/services/event';
import { Module } from 'vuex';
import { EditEvent, RegisterEvent, GetEvent } from '@/dtos/event.dto';

const event: Module<any, {}> = {
  state: {
    event: {
      data: null,
      isLoading: false,
    },
    events: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    // The upcoming rail asks the server for a different slice of the same table
    // (from a date, soonest first), so it is kept beside the calendar's list
    // rather than sharing it — either can reload without blanking the other.
    upcomingEvents: {
      data: null,
      metaData: null,
      isLoading: false,
    },
  },
  getters: {
    event: (state: { event: any }) => state.event,
    events: (state: { events: any }) => state.events,
    upcomingEvents: (state: { upcomingEvents: any }) => state.upcomingEvents,
  },
  mutations: {
    [SET_EVENT]: (
      state: { event: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.event.data = payload.data) : null,
        (state.event.isLoading = payload.isLoading);
    },
    [SET_EVENTS]: (
      state: { events: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.events.data = payload.data) : null,
      payload.metaData != null
          ? (state.events.metaData = payload.metaData)
          : null,
        (state.events.isLoading = payload.isLoading);
    },
    [SET_UPCOMING_EVENTS]: (
      state: { upcomingEvents: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.upcomingEvents.data = payload.data) : null,
      payload.metaData != null
          ? (state.upcomingEvents.metaData = payload.metaData)
          : null,
        (state.upcomingEvents.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EVENT]: async ({ commit }: any, payload: FormData) => {
      commit(SET_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Event.registerEvent(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EVENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT, { isLoading: false });
        return false;
      }
    },
    [GET_EVENTS]: async ({ commit }: any, payload: any) => {
      commit(SET_EVENTS, { data: null, isLoading: true });

      const result: AxiosResponse = await Event.getEvents(
        payload as GetEvent
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EVENTS, { data: result.data.data, metaData: result.data.metaData, isLoading: false });
          return true;
        }
        commit(SET_EVENTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENTS, { isLoading: false });
        return false;
      }
    },
    [GET_UPCOMING_EVENTS]: async ({ commit }: any, payload: any) => {
      commit(SET_UPCOMING_EVENTS, { data: null, isLoading: true });

      const result: AxiosResponse = await Event.getEvents(payload as GetEvent);

      if (result) {
        if (result.data.status) {
          commit(SET_UPCOMING_EVENTS, {
            data: result.data.data,
            metaData: result.data.metaData,
            isLoading: false,
          });
          return true;
        }
        commit(SET_UPCOMING_EVENTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_UPCOMING_EVENTS, { isLoading: false });
        return false;
      }
    },
    [GET_EVENT]: async ({ commit }: any, payload: any) => {
      commit(SET_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Event.getEvents(
        payload as GetEvent
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EVENT, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT, { isLoading: false });
        return false;
      }
    },
    [EDIT_EVENT]: async ({ commit }: any, payload: FormData) => {
      commit(SET_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Event.editEvent(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EVENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT, { isLoading: false });
        return false;
      }
    },
    [DELETE_EVENT]: async ({ commit }: any, payload: string) => {
      commit(SET_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Event.deleteEvent(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EVENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EVENT_ISLOADING]: ({ commit }) => {
      commit(SET_EVENT, { isLoading: false });
      commit(SET_EVENTS, { isLoading: false });
      commit(SET_UPCOMING_EVENTS, { isLoading: false });
    },
  },
};

export default event;
